import {Component, Inject, OnInit} from '@angular/core';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { MatSnackBar } from "@angular/material/snack-bar";
import { constants } from 'src/app/shared/common/contants';
import { AsignUserRoleService } from 'src/app/shared/services/asign-user-role.service';
import { EtlService } from 'src/app/user/vault-data-migration-etl/etl.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {MigrationConfigComponentServices} from 'src/app/shared/services/Migrationconfiguration';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomCheckBoxButton } from 'src/app/shared/common/checkBoxButton';
import { DeleteAndcheckboxComponent } from 'src/app/shared/common/deleteAndcheckButton'
import { CommonDownloadLinkFromS3 } from 'src/app/shared/common/commonDownloadLinkFromS3';
import { FiledownloadComponent } from 'src/app/shared/common/filedownload.component';
import { CommonService } from 'src/app/shared/services/common.service';
import { promise } from 'protractor';

export interface checkinListDialogData {
  edata: any;
  page: any;
  columns: any;
  remarksData: any;
  childId: any;
  screen:any;

}

@Component({
    selector: 'app-view-results',
    templateUrl: './view-results.component.html',
    styleUrls: ['./view-results.component.scss'],
    standalone: false
})



export class ViewResultsComponent implements OnInit {

  constructor(public dialogref: MatDialogRef<ViewResultsComponent>,private spinner:NgxUiLoaderService,private localStorageSettings: LocalStorageSettingsService,private snackbar: MatSnackBar,private constants: constants,private service:EtlService,private migrationconfigservices: MigrationConfigComponentServices,@Inject(MAT_DIALOG_DATA) public data: checkinListDialogData,private etlService: EtlService,private commonService: CommonService ) { 
    this.components = {
    downloadReportRef: CommonDownloadLinkFromS3,
    downloadbuttonRenderer: FiledownloadComponent,
    }
    }
    


      paginationPageSize
      paginationNumberFormatter
      pagesize
      totalpages
      currentpage
      gridAPIValidation
      RunpageSize
      RuntotalPages1
      RuncurrentPage1
      RunpageSize1 
      RunlastPage1
      RunnextPagePlusOne1
      RunnextPage1
      backgroundColorButton
      components
      columnDefsExtractTemp
      value
      selectedGrid ='new'
      selectedattributes
      rest:any = []
      defaultColDef
      CornerHeaderName
      bucketName
  ngOnInit(): void {
    this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
    
    console.log(this.data)
    this.selectedattributes = this.data.edata
    this.CornerHeaderName = this.data.screen;
   if(this.CornerHeaderName === 'Verify Mapping'){
    this.columnDefsExtractTemp = [     
          {
            headerName: 'Source Field Name',
            headerTooltip: 'Source Field Name',
            tooltipValueGetter: (params) => 'Source Field Name : ' + params.value,
            field: 'Source Field Name',
            filter: 'agTextColumnFilter',
            width: 180
          },
          {
            headerName: 'Target Field Name',
            headerTooltip: 'Target Field Name',
            tooltipValueGetter: (params) => 'Target Field Name : ' + params.value,
            field: 'Target Field Name',
            filter: 'agTextColumnFilter',
            width: 130
          },
          {
            headerName: 'Primary Key',
            headerTooltip: 'Primary Key',
            tooltipValueGetter: (params) => 'Primary Key : ' + params.value,
            field: 'Primary Key',
            filter: 'agTextColumnFilter',
            width: 130
          },
          {
            headerName: 'Source Value',
            headerTooltip: 'Source Value',
            tooltipValueGetter: (params) => 'Source Value : ' + params.value,
            field: 'Source Value',
            filter: 'agTextColumnFilter',
            width: 130
          },
          {
            headerName: 'Target Value',
            headerTooltip: 'Target Value',
            tooltipValueGetter: (params) => 'Target Value : ' + params.value,
            field: 'Target Value',
            filter: 'agTextColumnFilter',
            width: 130
          },
          {
            headerName: 'Mapping Id',
            headerTooltip: 'Mapping Id',
            tooltipValueGetter: (params) => 'Mapping Id : ' + params.value,
            field: 'Mapping Id',
            filter: 'agTextColumnFilter',
            width: 130
          },
          {
            headerName: 'Exception',
            headerTooltip: 'Exception',
            tooltipValueGetter: (params) => 'Exception : ' + params.value,
            field: 'Exception',
            filter: 'agTextColumnFilter',
            width: 130
          },
          {
            headerName: 'TestBed Id',
            headerTooltip: 'TestBed Id',
            tooltipValueGetter: (params) => 'TestBed Id : ' + params.value,
            field: 'TestBed Id',
            filter: 'agTextColumnFilter',
            width: 130
          },
          {
            headerName: 'Execution DateTime',
            headerTooltip: 'Execution DateTime',
            tooltipValueGetter: (params) => 'Execution DateTime : ' + params.value,
            field: 'Execution DateTime',
            filter: 'agTextColumnFilter',
            width: 130
          }
        ]
      }else{

        this.columnDefsExtractTemp = [     
          {
            headerName: 'Source File Name',
            headerTooltip: 'Source File Name',
            tooltipValueGetter: (params) => 'Source File Name : ' + params.value,
            field: 'Source File Name',
            filter: 'agTextColumnFilter',
            width: 180
          },
          {
            headerName: 'Stage File Name',
            headerTooltip: 'Stage File Name',
            tooltipValueGetter: (params) => 'Stage File Name : ' + params.value,
            field: 'Stage File Name',
            filter: 'agTextColumnFilter',
            width: 130
          },
          {
            headerName: 'Exception',
            headerTooltip: 'Exception',
            tooltipValueGetter: (params) => 'Exception : ' + params.value,
            field: 'Exception',
            filter: 'agTextColumnFilter',
            width: 130
          },
          {
            headerName: 'Mapping Id',
            headerTooltip: 'Mapping Id',
            tooltipValueGetter: (params) => 'Mapping Id : ' + params.value,
            field: 'Mapping Id',
            filter: 'agTextColumnFilter',
            width: 130
          },
          {
            headerName: 'TestBed Id',
            headerTooltip: 'TestBed Id',
            tooltipValueGetter: (params) => 'TestBed Id : ' + params.value,
            field: 'TestBed Id',
            filter: 'agTextColumnFilter',
            width: 130
          },
          {
            headerName: 'Execution DateTime',
            headerTooltip: 'Execution DateTime',
            tooltipValueGetter: (params) => 'Execution DateTime : ' + params.value,
            field: 'Execution DateTime',
            filter: 'agTextColumnFilter',
            width: 130
          },
          {
            headerName: 'Download Extraction File',
            headerTooltip: 'Download Extraction File',
            cellRenderer: "downloadbuttonRenderer",
            field: 'mappingversionpath',
            filter: 'agTextColumnFilter',
            cellRendererParams: {
              docdownload: this.downloadAttachmentLogs.bind(this),
              //delete: this.deleteIcon.bind(this),
            },
            width: 200
          },
        ]

      }

        this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };


        this.paginationPageSize = this.constants.pagesize;
  }


  onRunSearchChange(searchValue: number) {
        this.gridAPIValidation.paginationGoToPage(searchValue - 1);
      }
    
      // below function is for changing the no of rows per page
      onRunPageSizeChanged(newPageSize) {
        var value = this.RunpageSize1;
        this.gridAPIValidation.setGridOption('paginationPageSize', Number(value));
      }
      
      onBtExport(){
        this.gridAPIValidation.exportDataAsCsv();
      }
      

      onRunBtNext1() {
        console.log("next")
        this.gridAPIValidation.paginationGoToNextPage();
      }
    
      // below function for going to previous page
      onRunBtPrevious1() {
        console.log("previous")
        this.gridAPIValidation.paginationGoToPreviousPage();
      }
    
      // below function for going to first page
      onRunBtFirst1() {
        this.gridAPIValidation.paginationGoToFirstPage();
      }
    
      // below function for going to last page
      onRunBtLast1() {
        this.gridAPIValidation.paginationGoToLastPage();
      }
       
    
  
    
      onloadPaginationChanged1(){
        if (this.gridAPIValidation) {
          this.RunlastPage1 = this.gridAPIValidation.paginationIsLastPageFound();
          this.RuncurrentPage1 = this.gridAPIValidation.paginationGetCurrentPage() + 1
          this.RunnextPage1 = this.gridAPIValidation.paginationGetCurrentPage() + 1 + 1
          this.RunnextPagePlusOne1 = this.gridAPIValidation.paginationGetCurrentPage() + 1 + 1 + 1
          this.RuntotalPages1 = this.gridAPIValidation.paginationGetTotalPages()
        }
      }




  async cellClickedObjects(params) {
  this.spinner.start();
  this.gridAPIValidation = params.api;
  this.gridAPIValidation.setGridOption('rowData', []);

  console.log("----calling---");
  console.log(this.selectedattributes);
  let flag = 0
  if(this.CornerHeaderName != 'Verify Mapping'){
     flag = 1
  }
await this.getData();
}



  cancel(){
    this.dialogref.close();
  }

  async downloadAttachmentLogs(e){
    this.spinner.start();
    if(!this.bucketName){
     await this.getBucketName();
      console.log(this.bucketName);
    }
     let s3FilePath = this.bucketName+"/Test_Bed/TestBed_"+e.rowData["TestBed Id"]+"/Extraction/"+e.rowData["Stage File Name"]+".csv"

     let fileName=e.rowData["Stage File Name"]+".csv"
  if (s3FilePath === undefined || s3FilePath === "" || s3FilePath === null) {

    this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

  } else {
    this.snackbar.open("Download is underway. Please do not click again the download until it completes the download.", "OK", {duration: 10000});
    let data = {
      s3Path: s3FilePath,
    };
    this.spinner.start();
    this.commonService.downloadFileFromS3(data).subscribe(x => {
      this.spinner.stop()
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should

      console.log(x)
      const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
      const responseData = isJsonBlob(x)
      if (responseData) {
        this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

      } else {
        console.log(x)
        var newBlob = new Blob([x]);
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        console.log(data)

        var link = document.createElement('a');
        link.href = data;
        link.download = fileName;
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));
        setTimeout(function() {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
        /**
         * modified by Ashwin M
         * 08/01/2025
         * code modified to display file download confirmation
         */
        this.snackbar.open("Download Completed", "OK", {duration: 5000});
      }

    })

    this.spinner.stop();
  }
    this.spinner.stop();
  }


  getBucketName(): Promise<string> {
  return new Promise((resolve, reject) => {
    const dnsId = localStorage.getItem("dnsName");
    if (!dnsId) {
      return reject("DNS ID not found");
    }

    this.etlService.retrieveJsuiteProperty(dnsId, "BucketName").subscribe({
      next: (res) => {
        if (res.error) {
          return reject(res.statusMessage || "Error retrieving bucket name");
        }
        this.bucketName = res.propertyvalue;
        console.log("BucketName set to:", this.bucketName);
        resolve(this.bucketName);
      },
      error: (err) => {
        reject("API Error: " + err);
      }
    });
  });
}

 async getData():Promise<void>{
   this.spinner.start();
   const getBucketName=()=> new Promise<any>((resolve, reject) => {
    let dnsId = localStorage.getItem("dnsName");
     this.etlService.retrieveJsuiteProperty(dnsId, "BucketName").subscribe({
      next:(res)=>{
         if (res.error) {
            this.snackbar.open(res.statusMessage, 'OK', { duration: 5000 });
            return reject(res.statusMessage);
          }
          this.bucketName=res.propertyvalue
          resolve(this.bucketName)
      },
      error:reject
     })
   })
   const getVerifyResultsData=()=> new Promise<any>((resolve, reject) => {
     let flag = 0
  if(this.CornerHeaderName != 'Verify Mapping'){
     flag = 1
  }

  this.migrationconfigservices.retriveJsonData(this.selectedattributes, this.localStorageSettings.getSettings("WorkspaceId"),flag).subscribe({
    next:(res) => {
       if (res.error) {
            this.spinner.stop();
            this.snackbar.open(res.statusMessage, 'OK', { duration: 5000 });
            return reject(res.statusMessage);
          }
    console.log("----");
    console.log(res);
    this.rest = res; 
    const flattenedResult = [];

    this.rest.forEach(item => {
      const { Results = [], ...commonFields } = item;

      if (Array.isArray(Results) && Results.length > 0) {
        Results.forEach(resultItem => {
          flattenedResult.push({
            ...commonFields,
            ...resultItem
          });
        });
      } else {
        // If no Results array, push the item as is (optional behavior)
        flattenedResult.push({ ...commonFields });
      }
    });

    console.log(flattenedResult);
    this.gridAPIValidation.setGridOption('rowData', flattenedResult);
    resolve(flattenedResult)
  },
  error:reject
  });
   })
   try {
   await getBucketName();
   await getVerifyResultsData();
  } catch (err) {
    console.error("Error in getSourceTargetObjects:", err);
  } finally {
    this.spinner.stop();
  }
  
  }
}
